import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { NoContentBox } from '@upright/ui/common/generic/layout/no-content-box';
import { EmptyStateExampleFundProfilesCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/empty-state-example-fund-profiles-cta';
import { EmptyStateGetAccessCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/get-access';

export function InaccessibleHoldingsBox(props: { lensTypeToLinkTo?: ImpactLensType }) {
  return (
    <NoContentBox title="Subscribe to access full data">
      <EmptyStateGetAccessCTA />
      <EmptyStateExampleFundProfilesCTA lensTypeToLinkTo={props.lensTypeToLinkTo} />
    </NoContentBox>
  );
}
